import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const DTE_TYPE_OPTIONS = [
  { value: '', label: 'Todos los Documentos' },
  { value: '33', label: 'Factura Electrónica (33)' },
  { value: '34', label: 'Factura Exenta Electrónica (34)' },
  { value: '39', label: 'Boleta Electrónica (39)' },
  { value: '46', label: 'Factura de Compra Electrónica (46)' },
  { value: '52', label: 'Guía de Despacho Electrónica (52)' },
  { value: '61', label: 'Nota de Crédito Electrónica (61)' },
  { value: '80', label: 'Boleta de Honorarios Electrónica (80)' },
  { value: '90', label: 'Boleta de Honorarios a Terceros Electrónica (90)' },
  { value: '110', label: 'Factura de Exportación Electrónica (110)' }
]

const STATUS_OPTIONS = [
  { value: '', label: 'Todos los Estados' },
  { value: 'paid', label: 'PAGADA' },
  { value: 'unpaid', label: 'NO PAGADA' }
]

export default function AdminDocsFilters({ filters, setFilters, onApply, onClear }) {
  const setFilter = (k, v) => setFilters(prev => ({ ...prev, [k]: v }))

  return (
    <div className='border border-gray-200 rounded-md overflow-hidden'>
      <div className='flex items-center justify-between bg-gray-100 border-b border-gray-200 px-4 py-2'>
        <span className='font-semibold text-sm text-[#0066CC]'>SELECCIÓN DE DOCUMENTOS</span>
        <KeyboardArrowDownIcon className='text-gray-500' />
      </div>

      <div className='p-4 bg-white space-y-3'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          <div className='flex'>
            <span className='issuer-label-pill'>RUT RECEPTOR</span>
            <input
              className='input issuer-input'
              value={filters.rutReceptor}
              onChange={e => setFilter('rutReceptor', e.target.value)}
            />
          </div>

          <div className='flex'>
            <span className='issuer-label-pill'>FOLIO DOCUMENTO</span>
            <input
              className='input issuer-input'
              value={filters.folio}
              onChange={e => setFilter('folio', e.target.value)}
            />
          </div>
        </div>

        <div className='grid grid-cols-1'>
          <div className='flex'>
            <span className='issuer-label-pill'>RAZÓN SOCIAL</span>
            <input
              className='input issuer-input'
              value={filters.razonSocial}
              onChange={e => setFilter('razonSocial', e.target.value)}
            />
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          <div className='flex'>
            <span className='issuer-label-pill'>FECHA DESDE</span>
            <input
              type='date'
              className='input issuer-input'
              value={filters.fechaDesde}
              onChange={e => setFilter('fechaDesde', e.target.value)}
            />
          </div>

          <div className='flex'>
            <span className='issuer-label-pill'>FECHA HASTA</span>
            <input
              type='date'
              className='input issuer-input'
              value={filters.fechaHasta}
              onChange={e => setFilter('fechaHasta', e.target.value)}
            />
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          <div className='flex'>
            <span className='issuer-label-pill'>TIPO DOCUMENTO</span>
            <select
              className='input issuer-input'
              value={filters.tipoDocumento}
              onChange={e => setFilter('tipoDocumento', e.target.value)}
            >
              {DTE_TYPE_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>

          <div className='flex'>
            <span className='issuer-label-pill'>SITUACIÓN DOCUMENTO</span>
            <select
              className='input issuer-input'
              value={filters.estado}
              onChange={e => setFilter('estado', e.target.value)}
            >
              {STATUS_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className='flex justify-end gap-2 pt-2'>
          <button type='button' onClick={onApply} className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95'>
            Buscar Documentos
          </button>
          <button type='button' onClick={onClear} className='cursor-pointer rounded-lg bg-primary px-6 py-2.5 text-sm font-bold text-white shadow-lg shadow-black/20 transition-all hover:bg-primary/90 active:scale-95'>
            Limpiar
          </button>
        </div>

        <style>{sharedFilterStyles}</style>
      </div>
    </div>
  )
}

const sharedFilterStyles = `
  .input {
    width: 100%;
    padding: 0.35rem 0.6rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.4rem;
    outline: none;
    font-size: 0.8rem;
    background: #fff;
  }
  .issuer-label-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.3rem 0.6rem;
    font-size: 0.75rem;
    font-weight: 600;
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-right: 0;
    border-radius: 0.4rem 0 0 0.4rem;
    white-space: nowrap;
  }
  .issuer-input { border-radius: 0 0.4rem 0.4rem 0; }
`
